/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { Txn } from "@src/app/model/txn";
import { User } from "@src/app/model/user";
import { BankInPageComponent } from "@src/app/modules/txn/bank-in-page/bank-in-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

/** First of January, counting the current year as one of them */
const startOfYearsBack = (years: number) => `>=${new Date().getFullYear() - years + 1}-01-01`;

export const BankInPageNavRoute = new NavRoute(Txn.TYPE.BANK_IN.code, ()=>BankInPageComponent, 'call_received')
.setCharts([
    /* showOnly 0 so all twelve months show rather than the bar chart's usual top nine */
    { type: 'bar', picklist: 'month', number: 'debit', excludeZero: true, showOnly: 0, sortBy: 'id' } as ChartParms,
]).setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Bank receipts for the current financial year; change the year filter to view a different year',
            filterFields: {
                refNr: null,
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
            },
        },
        {
            id: 'twoYearComparison',
            name: 'Two Year Comparison',
            helpText: 'Receipts month by month for this calendar year beside the year before',
            filterFields: {
                refNr: null,
                txnCycleId: 'All',
                txnDate: startOfYearsBack(2),
            },
            charts: [
                { type: 'compareBar', picklist: 'year', trend: 'month', number: 'debit' } as ChartParms,
            ],
        },
        {
            id: 'threeYearComparison',
            name: 'Three Year Comparison',
            helpText: 'Receipts month by month for this calendar year beside the two before it',
            filterFields: {
                refNr: null,
                txnCycleId: 'All',
                txnDate: startOfYearsBack(3),
            },
            charts: [
                { type: 'compareBar', picklist: 'year', trend: 'month', number: 'debit' } as ChartParms,
            ],
        },
    ]
});
